import { invokeModuleMethod } from './moduleRuntimeHelpers.js';

export function createShelfUiActionFacade(context = {}) {
  const {
    ensureViewNavigationModuleReady,
    getViewNavigationModuleApi,
    ensureShelfViewModeModuleReady,
    getShelfViewModeModuleApi,
    ensureFormatPopoverModuleReady,
    getFormatPopoverModuleApi,
    ensureCategoryCollectionFiltersModuleReady,
    getCategoryCollectionFiltersModuleApi,
    ensureShelfSearchModuleReady,
    getShelfSearchModuleApi,
    ensureBatchSelectionModuleReady,
    getBatchSelectionModuleApi,
    ensureShelfDashboardModuleReady,
    getShelfDashboardModuleApi,
    showToast
  } = context;

  const noOp = () => {};
  const notifyBatchLoadFailed = () => {
    if (typeof showToast === 'function') {
      showToast('批量操作模块加载失败');
    }
  };

  function switchView(viewName) {
    invokeModuleMethod(getViewNavigationModuleApi, ensureViewNavigationModuleReady, 'switchView', [viewName], noOp);
  }

  function updatePrimaryActionButton() {
    invokeModuleMethod(getViewNavigationModuleApi, ensureViewNavigationModuleReady, 'updatePrimaryActionButton', [], noOp);
  }

  function handlePrimaryActionClick() {
    invokeModuleMethod(getViewNavigationModuleApi, ensureViewNavigationModuleReady, 'handlePrimaryActionClick', [], noOp);
  }

  function loadShelfViewMode() {
    invokeModuleMethod(getShelfViewModeModuleApi, ensureShelfViewModeModuleReady, 'loadShelfViewMode', [], noOp);
  }

  function updateShelfViewModeButton() {
    invokeModuleMethod(getShelfViewModeModuleApi, ensureShelfViewModeModuleReady, 'updateShelfViewModeButton', [], noOp);
  }

  function setViewMode(isGrid) {
    invokeModuleMethod(getShelfViewModeModuleApi, ensureShelfViewModeModuleReady, 'setViewMode', [isGrid], noOp);
  }

  function setupFormatEvents() {
    invokeModuleMethod(getFormatPopoverModuleApi, ensureFormatPopoverModuleReady, 'setupFormatEvents', [], noOp);
  }

  function updateFormatFilters() {
    invokeModuleMethod(getFormatPopoverModuleApi, ensureFormatPopoverModuleReady, 'updateFormatFilters', [], noOp);
  }

  function setupCategoryEvents() {
    invokeModuleMethod(
      getCategoryCollectionFiltersModuleApi,
      ensureCategoryCollectionFiltersModuleReady,
      'setupCategoryEvents',
      [],
      noOp
    );
  }

  function renderCategoryFilters() {
    invokeModuleMethod(
      getCategoryCollectionFiltersModuleApi,
      ensureCategoryCollectionFiltersModuleReady,
      'renderCategoryFilters',
      [],
      noOp
    );
  }

  function renderCollectionFilters() {
    invokeModuleMethod(
      getCategoryCollectionFiltersModuleApi,
      ensureCategoryCollectionFiltersModuleReady,
      'renderCollectionFilters',
      [],
      noOp
    );
  }

  function handleSearch(event) {
    invokeModuleMethod(getShelfSearchModuleApi, ensureShelfSearchModuleReady, 'handleSearch', [event], noOp);
  }

  function clearSearch() {
    invokeModuleMethod(getShelfSearchModuleApi, ensureShelfSearchModuleReady, 'clearSearch', [], noOp);
  }

  function enterSelectMode() {
    invokeModuleMethod(getBatchSelectionModuleApi, ensureBatchSelectionModuleReady, 'enterSelectMode', [], noOp);
  }

  function exitSelectMode() {
    invokeModuleMethod(getBatchSelectionModuleApi, ensureBatchSelectionModuleReady, 'exitSelectMode', [], noOp);
  }

  function toggleBookSelection(bookId) {
    invokeModuleMethod(getBatchSelectionModuleApi, ensureBatchSelectionModuleReady, 'toggleBookSelection', [bookId], noOp);
  }

  async function deleteSelectedBooks() {
    try {
      const mod = await ensureBatchSelectionModuleReady();
      await mod?.deleteSelectedBooks?.();
    } catch {
      notifyBatchLoadFailed();
    }
  }

  function showBatchCategoryModal() {
    invokeModuleMethod(
      getBatchSelectionModuleApi,
      ensureBatchSelectionModuleReady,
      'showBatchCategoryModal',
      [],
      notifyBatchLoadFailed
    );
  }

  function updateShelfStats() {
    invokeModuleMethod(getShelfDashboardModuleApi, ensureShelfDashboardModuleReady, 'updateShelfStats', [], noOp);
  }

  function updateWelcomeMessage(forceNew = false) {
    invokeModuleMethod(getShelfDashboardModuleApi, ensureShelfDashboardModuleReady, 'updateWelcomeMessage', [forceNew], noOp);
  }

  function updateRecentTimeline() {
    invokeModuleMethod(getShelfDashboardModuleApi, ensureShelfDashboardModuleReady, 'updateRecentTimeline', [], noOp);
  }

  return {
    switchView,
    updatePrimaryActionButton,
    handlePrimaryActionClick,
    loadShelfViewMode,
    updateShelfViewModeButton,
    setViewMode,
    setupFormatEvents,
    updateFormatFilters,
    setupCategoryEvents,
    renderCategoryFilters,
    renderCollectionFilters,
    handleSearch,
    clearSearch,
    enterSelectMode,
    exitSelectMode,
    toggleBookSelection,
    deleteSelectedBooks,
    showBatchCategoryModal,
    updateShelfStats,
    updateWelcomeMessage,
    updateRecentTimeline
  };
}
